"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _StoreInformationTile = require("@ccw-pwa-ui/StoreInformationTile");
var _SubNavHeading = require("@ccw-pwa-ui/SubNavHeading");
var _NavigateBackButton = require("@ccw-pwa-ui/NavigateBackButton");
var _ConnectionLoader = require("@ccw-pwa-ui/ConnectionLoader");
require("../styles/StoreDashBoardComponent.css");
var _SystemGatewayComponent = _interopRequireDefault(require("./SystemGatewayComponent"));
var _index = _interopRequireDefault(require("../common_features/assets/images/index"));
var _Modal = require("@ccw-pwa-ui/Modal");
const StoreDashboardComponent = _ref => {
  let {
    string,
    heading,
    subHeading,
    handleBack,
    name,
    address,
    separator,
    loginType,
    systems,
    gateways,
    data,
    onclick,
    gateLoading,
    sysLoading,
    systemType,
    gatewayType,
    waterDestinationItem,
    successLabel,
    rightButtonShow,
    everythingOkIcon,
    storeAlertList,
    isDisable,
    rightArrowBtn,
    everythingOkText,
    isSystem,
    statusIcon,
    statusText,
    Organization,
    onDetailsTileClick,
    optionBtnClick,
    dscIcon,
    systemsText,
    storeImage,
    storeImageStyle,
    imageLoading,
    showZoomImage,
    crossIconAction,
    zoomImageAction,
    displayZoomImage,
    userScreenPref
  } = _ref;
  const getGatewayInfo = () => {
    return systems.length > 0 ? /*#__PURE__*/_react.default.createElement(_SystemGatewayComponent.default, {
      systemType: systemType,
      onclick: onclick,
      gateways: gateways,
      gatewayType: gatewayType,
      systems: systems,
      waterDestinationItem: waterDestinationItem,
      isDisable: isDisable,
      rightArrowBtn: rightArrowBtn,
      everythingOkText: everythingOkText,
      statusIcon: statusIcon,
      statusText: statusText,
      optionBtnClick: optionBtnClick,
      gatewayName: "Gateway",
      dscIcon: dscIcon
    }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "storeDashboard-body"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "storeDashboard-mainHeading"
    }, string.MAIN_HEADING), string.MAIN_CONTENT.$$typeof ? string.MAIN_CONTENT : /*#__PURE__*/_react.default.createElement("div", {
      className: "storeDashboard-content"
    }, string.MAIN_CONTENT.toString()), /*#__PURE__*/_react.default.createElement("div", {
      className: "storeDash-subcontent"
    }, string.SUB_CONTENT), string.BOTTOM_CONTENT.$$typeof ? string.BOTTOM_CONTENT : /*#__PURE__*/_react.default.createElement("div", {
      className: "storeDash-bottom-content"
    }, string.BOTTOM_CONTENT.toString())));
  };
  const getStoreInfoTile = () => {
    return storeAlertList !== null && storeAlertList !== void 0 && storeAlertList.length ? /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "storeDetailTile"
    }, " ", /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
      name: name,
      address: address,
      arrowImage: _index.default.ArrowRight.default,
      Organization: Organization,
      loginType: loginType,
      rightButtonShow: rightButtonShow,
      successLabel: successLabel,
      everythingOkIcon: everythingOkIcon,
      storeAlertList: storeAlertList,
      handleBack: handleBack,
      onClick: onDetailsTileClick,
      isDisable: isDisable,
      isSystem: isSystem
    })) : /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "storeDetailTile"
    }, " ", /*#__PURE__*/_react.default.createElement(_StoreInformationTile.StoreInformationTile, {
      name: name,
      address: address,
      arrowImage: _index.default.ArrowRight.default,
      Organization: Organization,
      loginType: loginType,
      rightButtonShow: rightButtonShow,
      successLabel: successLabel,
      everythingOkIcon: everythingOkIcon,
      handleBack: handleBack,
      onClick: onDetailsTileClick,
      isDisable: isDisable,
      isSystem: isSystem
    }));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "storeDashboard-wrapper"
  }, sysLoading ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_SubNavHeading.SubNavHeading, {
    heading: heading,
    subHeading: subHeading,
    separator: separator
  }), /*#__PURE__*/_react.default.createElement(_NavigateBackButton.NavigateBackButton, {
    navHeading: userScreenPref && sessionStorage.getItem("Dispatcher_Web_Mobile_View") ? string.NAV_HEADING_CONTENT_WEB_VIEW : string.NAV_HEADING_CONTENT,
    leftArrowImage: _index.default.leftArrow.default,
    handleBack: handleBack
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "store-dashboard-body"
  }, sysLoading || imageLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : /*#__PURE__*/_react.default.createElement("div", {
    className: "store-image-div",
    onClick: zoomImageAction
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "store-image-img",
    src: storeImage,
    alt: "",
    style: storeImageStyle,
    onClick: zoomImageAction,
    "data-testid": "store-image-div"
  })), sysLoading ? "" : getStoreInfoTile(), sysLoading ? "" : /*#__PURE__*/_react.default.createElement("div", {
    className: "systems-text"
  }, systemsText), sysLoading ? /*#__PURE__*/_react.default.createElement(_ConnectionLoader.ConnectionLoader, null) : getGatewayInfo(), displayZoomImage ? /*#__PURE__*/_react.default.createElement("div", {
    className: "image-zoom-modal"
  }, /*#__PURE__*/_react.default.createElement(_Modal.Modal, {
    variant: "mobile-screen-zoom",
    displayModal: displayZoomImage,
    imageVariant: "zoom-image",
    zoomImageSrc: storeImage,
    displayCrossIcon: true,
    crossIconAction: crossIconAction
  })) : null));
};
var _default = exports.default = StoreDashboardComponent;